import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useTranslation } from "react-i18next";

/**
 * HeroStripe — kompakt greeting + sitat. Scroller bort med feeden.
 */
export default function HeroStripe() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const name = user?.display_name || user?.username || "";

  const hour = new Date().getHours();
  const greeting =
    hour < 5 ? t("home.good_night", "God natt") :
    hour < 12 ? t("home.good_morning", "God morgen") :
    hour < 18 ? t("home.good_afternoon", "God dag") :
    t("home.good_evening", "God kveld");

  return (
    <section className="pt-4 pb-5" data-testid="beta-hero">
      <div className="font-meta tracking-[0.3em] text-[var(--magenta)] mb-1 text-xs">
        {t("home.vol_norway", "VOL. I · NORSK EROTIKK")}
      </div>
      <h1 className="font-fraunces italic text-[var(--cream)] leading-tight text-3xl sm:text-4xl">
        {greeting}, <span className="text-[var(--magenta)]">{name}</span>.
      </h1>
    </section>
  );
}
